export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig();
	if (!config.public.GTAG_ID) return;

	useHead({
		script: [
			{
				innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.public.GTAG_ID}');`,
			},
		],
		noscript: [
			{
				innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${config.public.GTAG_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
				tagPosition: "bodyOpen",
			},
		],
	});
});
